import { EMPTY, map, of, switchMap } from 'rxjs';
import { ajax } from 'rxjs/ajax';
import Auth from '../../Auth';
import { notificationService } from '../common/NotificationService';

type ODataResponse = {
    '@odata.context': string;
};

export type ODataArrayResponse<T> = {
    '@odata.count': string;
    value: T[];
} & ODataResponse;

type ODataSingleResponse<T> = ODataResponse & T;

function fromAuthToken() {
    if (Auth.isExpired()) {
        notificationService.error({
            title: 'Session Expired',
            content: 'Please login again to re-authorize',
        });

        return EMPTY;
    }

    return of(`Bearer ${Auth.getToken()}`);
}

export function getODataObject<T>(url: string) {
    return fromAuthToken().pipe(
        switchMap((header) =>
            ajax<ODataSingleResponse<T>>({
                url,
                method: 'GET',
                responseType: 'json',
                headers: {
                    Authorization: header,
                },
            }),
        ),
        map((response) => response.response),
    );
}

export function getODataArray<T>(url: string) {
    return fromAuthToken().pipe(
        switchMap((header) =>
            ajax<ODataArrayResponse<T>>({
                url,
                method: 'GET',
                responseType: 'json',
                headers: {
                    Authorization: header,
                },
            }),
        ),
        map((response) => response.response),
        map((odataResponse) => odataResponse.value),
    );
}
